// @react/hooks/useLocalization.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { localizationStore } from '@core/stores';

/**
 * React hook for Locale operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useLocalization } from '@react/hooks';
 *
 * const LocaleList = observer(() => {
 *   const store = useLocalization();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useLocalization() {
  return localizationStore;
}
